/** User-facing strings: the OPC UA browser page and the tree package's node details panel (#121, #141). */
export const browse = {
    page: {
        addressSpace: "Address space",
        selected: "Selected",
        details: "Details",
        backToTree: "Back to the tree",
        tapHint: "Tap a node to open it, then see its details here.",
    },
    display: {
        toolbar: "Tree display",
        look: "Tree look",
        classic: "Classic",
        modern: "Modern",
        options: "Display",
        optionsChanged: "Display, {count, plural, one {# option} other {# options}} changed",
        boxStyle: "Node boxes",
        boxNone: "Flat rows",
        boxOpcuaBlue: "OPC UA blue",
        boxTheme: "Theme",
        boxNamespace: "Colour by namespace",
        show: "Show",
        values: "Values",
        references: "Other references",
        browseNames: "Browse names",
        namespacePrefix: "Namespace prefix",
        eventIndicator: "Event sources",
        typeHierarchyOnly: "Types: subtypes only",
        focusAll: "Namespaces: all",
        focusSome: "Namespaces: {count} selected",
        focusHint: "Show only the branches that lead to nodes of these namespaces.",
        focusAllItem: "All namespaces",
        reset: "Reset to defaults",
        reload: "Reload the tree",
    },
    tree: {
        error: "Could not read this node.",
    },
    details: {
        heading: "Node details",
        empty: "Select a node in the tree to see its details.",
        refresh: "Refresh",
        refreshLabel: "Refresh the details of node {nodeId}",
        nodeId: "Node ID",
        nodeIdCopy: "Copy the node ID of {name}",
        copy: "Copy",
        copied: "Copied",
        attributesTab: "Details",
        deviceTab: "Device",
        diagramTab: "Diagram",
        stateMachineTab: "State machine",
        loading: "Reading the attributes…",
        readFailed: "Could not read the attributes of this node.",
        unknownNode: "Unknown node",
        monitor: "Monitor",
        monitorLabel: "Monitor the value of {name}",
        monitorHint: "Reads the value again about every second and a half.",
        path: "Path",
        displayName: "Display name",
        browseName: "Browse name",
        nodeClass: "Node class",
        description: "Description",
        noDescription: "No description",
        dataType: "Data type",
        value: "Value",
        valueReadFailed: "Could not read the value.",
        noValue: "No value",
        status: "Status",
        sourceTimestamp: "Source timestamp",
        serverTimestamp: "Server timestamp",
        noTimestamp: "None",
        access: "Access level",
        userAccess: "Access for you",
        attributeBad: "{name} could not be read: {status}",
        inputArguments: "Input arguments",
        outputArguments: "Output arguments",
        noArguments: "None",
        argumentName: "Name",
        argumentType: "Type",
        executable: "Executable",
        userExecutable: "for you",
        scalarOrArray: "scalar or array",
        anyRank: "any",
        yes: "yes",
        no: "no",
    },
    diagram: {
        loading: "Drawing the diagram…",
        failed: "Could not draw the diagram.",
        retry: "Retry",
        diagramLabel: "Class diagram of {name}",
        fit: "Fit",
        actualSize: "Actual size",
    },
    stateMachine: {
        loading: "Drawing the state machine…",
        failed: "Could not draw the state machine.",
        retry: "Retry",
        currentState: "Current state: {name}",
        noCurrentState: "No current state",
        notAStateMachine: "This node is not a state machine.",
        diagramLabel: "State machine of {name}",
        lastTransition: "Last transition: {name}",
        fit: "Fit",
        actualSize: "Actual size",
    },
    status: {
        good: "Good",
        uncertain: "Uncertain",
        bad: "Bad",
    },
    access: {
        none: "No access",
        read: "Read",
        write: "Write",
        historyRead: "History read",
        historyWrite: "History write",
        semanticChange: "Semantic change",
        statusWrite: "Status write",
        timestampWrite: "Timestamp write",
    },
    nodeClass: {
        object: "Object",
        variable: "Variable",
        method: "Method",
        objectType: "Object type",
        variableType: "Variable type",
        referenceType: "Reference type",
        dataType: "Data type",
        view: "View",
        unknown: "Node",
    },
};
